module.exports = __webpack_public_path__ + "img/beer_id-108.0f939680.png";